import { showToast } from "../../../utils/utility";

export const handleValidateStudentWorking = (payload: any) => {
  // ---------- Attendance context ----------
  if (!payload?.class_id) {
    showToast({ type: "warning", message: "Please select class" });
    return false;
  }

  if (!payload?.section_id) {
    showToast({ type: "warning", message: "Please select section" });
    return false;
  }

  if (!payload?.year) {
    showToast({ type: "warning", message: "Please select year" });
    return false;
  }

  if (!payload?.month) {
    showToast({ type: "warning", message: "Please select month" });
    return false;
  }

  if (
    payload?.total_working_days === undefined ||
    payload?.total_working_days <= 0
  ) {
    showToast({
      type: "warning",
      message: "Total working days must be greater than 0",
    });
    return false;
  }

  // ---------- Students ----------
  if (!Array.isArray(payload?.students) || payload.students.length === 0) {
    showToast({
      type: "warning",
      message: "No students found for attendance entry",
    });
    return false;
  }

  const invalidStudent = payload.students.find(
    (s: any) =>
      s.present_days === undefined ||
      s.present_days < 0 ||
      s.present_days > payload.total_working_days,
  );

  if (invalidStudent) {
    showToast({
      type: "warning",
      message:
        "Present days must be between 0 and total working days for all students",
    });
    return false;
  }

  return true;
};
